import { FunctionComponent } from 'react'
import styles from './CALDHome.module.scss'
import Title from '@/components/_custom/Title/title'
import { useTranslation } from 'react-i18next'
import { NavigateFunction, useNavigate } from 'react-router-dom'
import { useAuth } from '@/modules/context/AuthContext'
import LogoutIcon from '@mui/icons-material/ExitToApp'
import CachedIcon from '@mui/icons-material/Cached'
import { removeServiceWorker } from '@/modules/utils/serviceWorker'
import SettingsIcon from '@mui/icons-material/Settings'
import HomeCase from '../HomeCase/homeCase'

interface CALDHomeDesktopProps {
    backendVersion: string
    frontendVersion: string
    setDialogSupportOpen: (open: boolean) => void
}

const CALDHomeDesktop: FunctionComponent<CALDHomeDesktopProps> = ({
    backendVersion,
    frontendVersion,
    setDialogSupportOpen
}: CALDHomeDesktopProps) => {
    const { t } = useTranslation()

    const { logout } = useAuth()

    const navigate: NavigateFunction = useNavigate()

    return (
        <div className={styles.PagePosition}>
            <div className={styles.HomePlacement}>
                <Title text={`${t('settings')} - CALD`} className={styles.Title} />
                <div className={styles.CaseContainer}>
                    <HomeCase
                        text={t('settings')}
                        icon={<SettingsIcon className={styles.CaseIcon} />}
                        onClick={(): void | Promise<void> => navigate('/settings')}
                    />
                    <HomeCase
                        text={t('refresh')}
                        icon={<CachedIcon className={styles.CaseIcon} />}
                        onClick={removeServiceWorker}
                    />
                    <HomeCase text={t('logout')} icon={<LogoutIcon className={styles.CaseIcon} />} onClick={logout} />
                </div>
            </div>
            <div className={styles.Version}>
                <a onClick={() => setDialogSupportOpen(true)}>
                    V{backendVersion}/{frontendVersion}
                </a>
            </div>
        </div>
    )
}

export default CALDHomeDesktop
